var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrganizerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "organizer-icon",
    transform: "translate(-1037.742 151.489)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19045",
    "data-name": "Path 19045",
    d: "M1063.29-143.089a4.2,4.2,0,0,0,4.2-4.2,4.2,4.2,0,0,0-4.2-4.2,4.2,4.2,0,0,0-4.2,4.2,4.2,4.2,0,0,0,4.2,4.2m0-7.2a3,3,0,0,1,3,3,3,3,0,0,1-3,3,3,3,0,0,1-3-3,3,3,0,0,1,3-3",
    transform: "translate(-16.548)",
    fill: "#9cdbd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19046",
    "data-name": "Path 19046",
    d: "M1052.143-108.794h-10.8a3.6,3.6,0,0,0-3.6,3.6v4.8h1.2v-4.8a2.4,2.4,0,0,1,2.4-2.4h10.8a2.4,2.4,0,0,1,2.4,2.4v4.8h1.2v-4.8a3.6,3.6,0,0,0-3.6-3.6",
    transform: "translate(-0.001 -33.095)",
    fill: "#9cdbd9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_699",
    "data-name": "Rectangle 699",
    width: 18,
    height: 1.2,
    transform: "translate(1037.742 -134.689)",
    fill: "#9cdbd9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizerIcon);
export default __webpack_public_path__ + "static/media/organizer-icon.4ba35c4b0d6ec6ec90bafa999780ec05.svg";
export { ForwardRef as ReactComponent };